import { render } from "./CompanyClient.vue?vue&type=template&id=21b48dca&scoped=true"
import script from "./CompanyClient.vue?vue&type=script&lang=js"
export * from "./CompanyClient.vue?vue&type=script&lang=js"

import "./CompanyClient.vue?vue&type=style&index=0&id=21b48dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b48dca"]])

export default __exports__